import React, {useContext} from 'react';
import {LocaleLink} from '@/routes';
import logo from '@/assets/images/logo.png';
import ipcLogo from '@/assets/images/ipc_logo.png';
import absgLogo from '@/assets/images/absg_logo.svg';
import LangMenu from '@/views/Layout/Public/LangMenu';
import styles from '@/views/Layout/Public/index.module.css';

import {SystemConfigCtx} from '@/contexts';
import {blank} from '@/util';

const Header = () => {
  const {siteCode} = useContext(SystemConfigCtx);

  if (blank(siteCode)) {
    return null;
  }

  const colorClass = {
    afs: styles.headerAfs,
    ipc: styles.headerIpc,
  };

  return (
    <header className={`${colorClass[siteCode]}`}>
      <div className='container clearfix'>
        <LocaleLink to='/'>
          {siteCode === 'afs' && (
            <img
              alt='Athena Best'
              src={logo}
              style={{width: '120px', height: '114px', marginTop: '10px'}}
            />
          )}
          {siteCode === 'ipc' && (
            <img alt='IPC' src={ipcLogo} style={{marginTop: '10px'}} />
          )}
          {siteCode === 'absg' && (
            <img alt='ABSG' src={absgLogo} style={{marginTop: '10px'}} />
          )}
        </LocaleLink>
        <nav className='wide'>
          <ul className='clearfix'>
            <LangMenu />
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
